import { render, staticRenderFns } from "./company-work.vue?vue&type=template&id=19b0a23b&scoped=true"
import script from "./company-work.vue?vue&type=script&lang=js"
export * from "./company-work.vue?vue&type=script&lang=js"
import style0 from "./company-work.vue?vue&type=style&index=0&id=19b0a23b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b0a23b",
  null
  
)

export default component.exports